// FU-m: a typed group-by-not-applicable failure on one arm of a multi-walk tile. Pure
// presentational; the string lives in chartChrome. No Retry — the failure is deterministic.
import { Alert } from '@mui/material'
import { groupByNotApplicableNote } from '~/components/Charts/chrome/chartChrome'

export function DimNotApplicableNote({
  dims,
  metricLabel,
}: {
  dims: string[]
  metricLabel?: string
}) {
  return (
    <Alert severity="warning" sx={{ py: 0 }}>
      {groupByNotApplicableNote(dims, metricLabel)}
    </Alert>
  )
}
